import React from 'react';

const AddItemsCard = (props) => {
    const { toggle, name, count } = props;

    return (
        <>
            <div className="addItems cursor col-lg-5 bg-white px-3 py-2 mb-3 d-flex align-items-center justify-content-between"
                onClick={toggle}>
                <div className="d-flex align-items-center">
                    <span className="addItemsOptIcon ml-3 rounded-circle text-black bg-white d-flex align-items-center justify-content-center">
                        <i className="icon-plug"></i>
                    </span>
                    <p className="m-0 fn12">{name}</p>
                </div>
                <p className="fn12 m-0 text-muted">{count}</p>
            </div>
        </>
    );
};

export { AddItemsCard };